import { Stack } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { Optional } from '@vy/utils';
import { VyRadioCard } from '../../../../../../components/new-design/inputs/VyRadioCard';
import { PRODUCT_TYPE, type ProductType } from '../../ProductsTable/products-columns/products-columns-type';

type ProductCreationStepperDialogContentProps = {
  selectedProductType: Optional<ProductType>;
  handleProductTypeSelection: (type: ProductType) => void;
};

export const ProductCreationStepperDialogContent: React.FC<ProductCreationStepperDialogContentProps> = ({
  selectedProductType,
  handleProductTypeSelection,
}) => {
  const isMetered = selectedProductType === PRODUCT_TYPE.METERED;
  const isService = selectedProductType === PRODUCT_TYPE.SERVICE;
  const isCredit = selectedProductType === PRODUCT_TYPE.CREDIT;

  return (
    <Stack direction="row" spacing={2}>
      <VyRadioCard
        title="Metered product"
        titleSx={{ fontSize: '14px !important', fontWeight: 600 }}
        description="Charge based on customer usage, like API calls or data volume."
        descriptionSx={{ fontWeight: '12px' }}
        icon={<VyIcon icon="BusinessChart" />}
        iconBackgroundColor="#B0D2FF"
        selected={isMetered}
        onClick={() => handleProductTypeSelection(PRODUCT_TYPE.METERED)}
      />
      <VyRadioCard
        title="Standard or service product"
        titleSx={{ fontSize: '14px !important', fontWeight: 600 }}
        description="Define new Services and products with fixed fees."
        descriptionSx={{ fontWeight: '12px' }}
        icon={<VyIcon icon="DataStorage" />}
        iconBackgroundColor="#B0D2FF"
        selected={isService}
        onClick={() => handleProductTypeSelection(PRODUCT_TYPE.SERVICE)}
      />
      <VyRadioCard
        title="Credit product"
        titleSx={{ fontSize: '14px !important', fontWeight: 600 }}
        description="Prepaid credits applied to usage within a contract"
        descriptionSx={{ fontWeight: '12px' }}
        icon={<VyIcon icon="MoneyBanknotes" />}
        iconBackgroundColor="#B0D2FF"
        selected={isCredit}
        onClick={() => handleProductTypeSelection(PRODUCT_TYPE.CREDIT)}
      />
    </Stack>
  );
};
